import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import {
    FormikInput,
    FormikSingleFileUpload,
} from "../../../../components/formik-components";
import { respEnum } from "../../../../constants/appConstant";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import common from "../../../../helper/common";
import '../../../../assets/nascent.css';

const FormikInitialValues = {};
const formikValidation = yup.object({
    name: yup.string().required("Name is required"),
});

const AddFacility = ({ id, onClose, open, setOpen }) => {
    const formikRef = useRef();
    const dialogRef = useRef();
    const navigate = useNavigate();
    const [isFormikInitialized, setIsFormikInitialized] = useState(false);

    useEffect(() => {
        setIsFormikInitialized(open);
    }, [open]);

    const onSubmitData = async (d, action) => {
        
        if (!d.files && !d.icon) {
            Common.SweetAlert.alert('Select Icon ', 'error')
            return;
        }
        if (d.files && d.files.filter((item) => !item.imageUrl).length) {
            d.icon = (await Common.Utility.handleFileUpload(d.files))[0].photo;
            d.files = null;
        }
        let data = {
            ...d,
            id,
        };
        let response = await Common.ApiService.getInstance().request(
            "AddUpdateMasterFacility",
            data,
            "POST"
        );
        action.setSubmitting(false);
        if (response.status === respEnum.Success) {
            onClose(response.data);
            setOpen(false);
            if (!onClose) {
                navigate("/app/facilities", { replace: true });
            }
        }
    };

    const getDataInfo = async () => {
        
        let response = await Common.ApiService.getInstance().request(
            `GetMasterFacilities?id=${id}`
        );
        if (response.status === respEnum.Success && response.data.length > 0) {
            formikRef.current.setValues(response.data[0]);
        }
    };

    useEffect(() => {
        if (id) {
            getDataInfo();
        }
    }, [id]);

    return (
        <div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    {/*<Button*/}
                    {/*    style={{ marginTop: "-15px" }}*/}
                    {/*    size="icon"*/}
                    {/*    variant="ghost"*/}
                    {/*    className="group p-1 "*/}
                    {/*>*/}
                    {/*    <Icon icon="heroicons:plus-20-solid" className=" h-6 w-6 " />*/}

                    {/*</Button>*/}
                    <Button
                        //onClick={() => setOpen(true)}
                        size="sm"
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" /> 
                        Add Facility
                    </Button>
                </DialogTrigger>
                <DialogContent ref={dialogRef} className="custom-dialog">
                    <DialogHeader>
                        <DialogTitle>{id ? "Update" : "Add"} Facility</DialogTitle>
                    </DialogHeader>

                    <div className="text-sm text-default-500  space-y-2">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                                    <div className="col-span-1">
                                        <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"name"}
                                                    label={"Name"}
                                                    placeholder={"Name"}
                                                    maxLength="25"
                                                />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <FormikSingleFileUpload
                                                    formikProps={formikProps}
                                                    uploadMainTxt="Upload Icon"
                                                    uploadTxt="Max size 2mb"
                                                    name="icon"
                                                    maxFileUploadSize={2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                    <DialogFooter className="mt-8 gap-2">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>

                        {isFormikInitialized && formikRef.current && (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {formikRef.current.isSubmitting
                                    ? "Saving..."
                                    : !id
                                        ? "Add"
                                        : "Update"}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddFacility;
